import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import RoadmapCarousel from './RoadmapCarousel';
import './About.css';

const About = () => {
  const { t, language } = useLanguage();
  const isEN = language === 'en';

  return (
    <section className="about section" id="about">
      <div className="container">
        <motion.div
          className="about-roadmap"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          viewport={{ once: true, amount: 0.1 }}
        >
          {/* Header — mismo patrón que ProcessSteps */}
          <div className="ps-header ps-header--center">
            <div className="ps-eyebrow">
              <span className="ps-eyebrow-dot" />
              {isEN ? 'roadmap' : 'hoja de ruta'}
            </div>
            <div className="ps-header-row">
              <h2 className="ps-title">
                {isEN
                  ? <><span className="ps-title-accent">WhataRoadmap.</span><br />Active protocol.</>
                  : <><span className="ps-title-accent">WhataRoadmap.</span><br />Protocolo activo.</>
                }
              </h2>
            </div>
          </div>

          <RoadmapCarousel />
        </motion.div>
      </div>
    </section>
  );
};

export default About;
